import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    quote:
      '"JANM Engineering didn\'t just build our platform — they architected a solution that handled a 10× user spike without a single hiccup. That\'s not a vendor. That\'s a world-class engineering partner."',
    name: 'Sarah Chen',
    role: 'CTO, NexaFlow Startups',
  },
  {
    quote:
      '"The technical depth and product intuition JANM brings is unmatched. They operate like elite internal co-founders. Our AI system went from concept to production in 6 weeks. Extraordinary."',
    name: 'Marcus Doe',
    role: 'Founder, Visionary AI Labs',
  },
];

const Testimonials = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="section testimonials-section" id="testimonials" ref={ref}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={visible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          style={{ textAlign: 'center', marginBottom: '80px' }}
        >
          <p className="section-label" style={{ textAlign: 'center' }}>Trust</p>
          <h2 className="section-title" style={{ textAlign: 'center' }}>
            Backed by Visionaries.
          </h2>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              className="testimonial-card"
              initial={{ opacity: 0, y: 40 }}
              animate={visible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.15 * i, ease: [0.16, 1, 0.3, 1] }}
            >
              <p className="testimonial-quote">{t.quote}</p>
              <div className="testimonial-author">
                <h4>{t.name}</h4>
                <p>{t.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
